import currentItemSlice from './slice'

// eslint-disable-next-line import/prefer-default-export
export const currentItemStateActions = currentItemSlice.actions
